/* eslint-disable @typescript-eslint/no-explicit-any */
import AT from '../constants/action-types';
import * as R from 'ramda';

const initialState = {
  myControlBoxes: []
};

function mapControlBox(cbx: any) {
  return {
    ...cbx,
    lastSeenOnline: new Date(cbx.lastSeenOnline)
  };
}

export default function app(state = initialState, action: any = {}) {
  switch (action.type) {
    case AT.FETCH_CONTROL_BOXES_DONE: {
      return { ...state, myControlBoxes: action.data.items.map(mapControlBox) };
    }

    case AT.ITEM_DELETE_DONE:
      if (action.itemType === 'ControlBox') {
        return {
          ...state,
          myControlBoxes: R.reject((s: any) => s._id === action.itemId, state.myControlBoxes)
        };
      }

      return state;
    case AT.FETCH_CBX_QUEUE_STATUS_DONE: {
      const cbxStatuses = action.data.controlBoxes;
      const myControlBoxes = state.myControlBoxes.map((cbx: any) => {
        const cbxWithNewStatus = R.find((c: any) => c._id === cbx._id, cbxStatuses);
        if (cbxWithNewStatus && cbx.connectionStatus !== cbxWithNewStatus.connectionStatus) {
          return {
            ...cbx,
            connectionStatus: cbxWithNewStatus.connectionStatus,
            lastSeenOnline: new Date(cbxWithNewStatus.lastSeenOnline)
          };
        }
        return cbx;
      });
      return { ...state, myControlBoxes };
    }
    default:
      return state;
  }
}
